import { render, staticRenderFns } from "./networkSwitch.vue?vue&type=template&id=b387a51c&scoped=true&"
import script from "./networkSwitch.vue?vue&type=script&lang=js&"
export * from "./networkSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b387a51c",
  null
  
)

export default component.exports